// extracted by mini-css-extract-plugin
module.exports = {"box":"seckillRules_box_Fic0K","title":"seckillRules_title_2F9dc","content":"seckillRules_content_mVN0c"};